import { useSearchParams } from 'react-router-dom';

type SourceScreen =
  | 'PROFILE'
  | 'MEMBERS'
  | 'ADMIN'
  | 'DELETION'
  | 'DATA_CHANGE'
  | 'ACCOUNT_WITHOUT_PASSWORD';

export function useSourceScreen() {
  const [search] = useSearchParams();

  function getSourceScreen(): SourceScreen {
    return (search.get('src') as SourceScreen) ?? 'PROFILE';
  }

  const sourceScreen = getSourceScreen();

  const isSource = (src: SourceScreen) => src === sourceScreen;

  const isDeletion = sourceScreen === 'DELETION';
  const isProfile = sourceScreen === 'PROFILE';
  const isAdmin = sourceScreen === 'ADMIN';
  const isDataChange = sourceScreen === 'DATA_CHANGE';
  const isMember = sourceScreen === 'MEMBERS';

  return {
    isAdmin,
    isMember,
    isSource,
    isProfile,
    isDeletion,
    isDataChange,
    sourceScreen,
  };
}
